import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { utc } from '@date-fns/utc';
import { format, parseISO } from 'date-fns';
import { AccountTransactionDirection } from '@/modules/__generated__/graphql/switchboard-generated';
import { usLocalizedNumber } from '@/modules/shared/lib/humanization';
import { TxHash } from '../tx-hash';
import { ExpenseArrow } from './expense-arrow';
import { WalletInfo } from './wallet-info';
import type { TransactionProps } from './transaction';
function DesktopTransaction(t0) {
  const $ = _c(44);
  const {
    label,
    date,
    toDate,
    amount,
    txHash,
    counterPartyName,
    counterPartyAddress,
    highlightPositiveAmounts: t1,
    direction
  } = t0;
  const highlightPositiveAmounts = t1 === undefined ? false : t1;
  const isIncomingTransaction = direction === AccountTransactionDirection.Inflow;
  let t2;
  if ($[0] !== date || $[1] !== toDate) {
    t2 = toDate ? `${format(parseISO(date), "dd-MMM-yyyy", {
      in: utc
    })} to ${format(parseISO(toDate), "dd-MMM-yyyy", {
      in: utc
    })}` : `${format(parseISO(date), "dd-MMM-yyyy HH:mm", {
      in: utc
    })} UTC`;
    $[0] = date;
    $[1] = toDate;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const formattedDate = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("grid py-[6px] pr-6 pb-[5px] pl-3", "grid-cols-[172px_1fr_max-content]", "not-first-of-type:border-border not-first-of-type:border-t", "hover:bg-muted", "md:grid-cols-[calc(var(--spacing)*63)_1fr_max-content] md:py-[6px] md:pr-10 md:pb-[5px] md:pl-2", "lg:grid-cols-[calc(var(--spacing)*99)_1fr_max-content] lg:py-2 lg:pr-4 lg:pb-[7px] lg:pl-5", "xl:grid-cols-[calc(var(--spacing)*101.5)_1fr_max-content] xl:py-2 xl:pb-[7px] xl:pl-5");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = label === "Swap";
  let t5;
  if ($[4] !== isIncomingTransaction || $[5] !== t4) {
    t5 = <ExpenseArrow isIncoming={isIncomingTransaction} isSwap={t4} className="mt-1.25 size-6 min-w-6" />;
    $[4] = isIncomingTransaction;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== label) {
    t6 = <div className="text-sm/5.5 font-medium md:font-semibold">{label}</div>;
    $[7] = label;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== formattedDate) {
    t7 = <div className="text-foreground/30 text-xs/4.5 uppercase">{formattedDate}</div>;
    $[9] = formattedDate;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== txHash) {
    t8 = <TxHash txHash={txHash} />;
    $[11] = txHash;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
    t9 = <div className="flex flex-col">{t6}{t7}{t8}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t5 || $[18] !== t9) {
    t10 = <div className="flex gap-2 lg:gap-4">{t5}{t9}</div>;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = isIncomingTransaction ? "Sender Address" : "Recipient Address";
  let t12;
  if ($[20] !== t11) {
    t12 = <div className="text-foreground/50 text-xs/4.5">{t11}</div>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== counterPartyAddress || $[23] !== counterPartyName) {
    t13 = <WalletInfo name={counterPartyName} address={counterPartyAddress} />;
    $[22] = counterPartyAddress;
    $[23] = counterPartyName;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t12 || $[26] !== t13) {
    t14 = <div className="flex flex-col gap-0.5 pr-2.5 lg:ml-4">{t12}{t13}</div>;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="text-foreground/50 text-xs/4.5">Amount</div>;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const t16 = isIncomingTransaction && !!highlightPositiveAmounts ? "text-status-success" : "text-foreground";
  let t17;
  if ($[29] !== t16) {
    t17 = cn("flex items-baseline gap-1 text-sm/5.5 font-semibold", t16);
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  const t18 = isIncomingTransaction ? "+" : "-";
  let t19;
  if ($[31] !== t18) {
    t19 = <span>{t18}</span>;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== amount) {
    t20 = usLocalizedNumber(amount);
    $[33] = amount;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="text-foreground/30 text-xs/4.5 font-medium">USD</span>;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t17 || $[37] !== t19 || $[38] !== t20) {
    t22 = <div className="flex flex-col items-end justify-start gap-4 lg:justify-center lg:gap-2 lg:pr-10 xl:pr-12">{t15}<div className={t17}>{t19}{t20}{t21}</div></div>;
    $[36] = t17;
    $[37] = t19;
    $[38] = t20;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t10 || $[41] !== t14 || $[42] !== t22) {
    t23 = <div className={t3}>{t10}{t14}{t22}</div>;
    $[40] = t10;
    $[41] = t14;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  return t23;
}
export { DesktopTransaction };